export const UNDER = "under-zpd";
export const OVER = "over-zpd";
export const AT = "at-zpd";

export const LOWER_RANGE = 100;
export const UPPER_RANGE = 50;

export function getTextStatus(textLexile, studentLexile) {
	var levelsComparison = parseInt(studentLexile) - parseInt(textLexile);

	if (levelsComparison < -UPPER_RANGE) {
		return OVER;
	} else if (levelsComparison <= LOWER_RANGE) {
		return AT;
	} else {
		return UNDER;
	}
}


// WEBPACK FOOTER //
// ./modules/lib/academic/ZPDRange.js